// Telas da Visão Empresa que um EMP abre por permissão. Um lugar só para o menu
// (MenuCompany), os guards das rotas (App.js) e o seletor "Visão Empresa"
// (Layout). Só usabilidade: quem barra é o back.
//
// Telas só do ADM (padrões de contrato, permissões, alertas, quiz,
// declarações, API keys) ficam fora do mapa. Quando uma ganhar
// permissão, entra aqui e ganha um guard próprio no App.js com `screen`.

/** Tela → strings que a abrem (qualquer uma basta). ADM abre todas. */
export const COMPANY_SCREENS = Object.freeze({
	// "Ver projetos" (todos) ou itens de horas (os projetos em que valem)
	projects: ["projects:read", "project_hours:read", "project_hours:approve"],
	// Só leitura com "Ver horas"; aprovar e reprovar com os itens de aprovação
	hoursApproval: ["project_hours:read", "project_hours:approve"],
	contracts: ["contracts:read"],
	// Inclui os lançamentos de valor (/c/contracts/value-approvals)
	paymentSchedules: ["payment_schedules:read"],
	employees: ["users:read"],
	taxInvoices: ["tax_invoices:read"],
	timeClock: ["time_clock:read"],
	// Só a lista e o download; enviar, editar e excluir seguem só ADM
	documents: ["documents:read"],
});

/**
 * `user` ({ role, permissions }) abre a tela? Recebe o usuário em vez de ler o
 * user_ow porque o Layout decide também com as permissões recém-lidas do /me.
 * Permissão por projeto conta pela string: quem a tem em algum projeto abre a tela.
 */
export function canOpenScreen(screen, user) {
	if (user?.role === "ADM") return true;
	const permissions = user?.permissions || [];
	return (COMPANY_SCREENS[screen] || []).some((p) => permissions.includes(p));
}

/**
 * As permissões abrem alguma tela da Visão Empresa? Decide se o EMP vê o seletor
 * de visão (o ADM está sempre nela). Tela nova no mapa já entra aqui.
 */
export function hasCompanyView(user) {
	const permissions = user?.permissions || [];
	return Object.values(COMPANY_SCREENS).some((list) => list.some((p) => permissions.includes(p)));
}
